<template>
    <mdc-dialog  class="fullscreen-modal"
                v-model="isOpen"
                :title="'protocol.add_to_set' | trans"
                :accept="'behavior.buttons.create' | trans"
                :cancel="'behavior.buttons.cancel' | trans"
                @cancel="cancel"
                @validate="validate()"
                @close="close"
                :class="{'fullscreen-dialog' : isMobile}">
  
        <div v-if="isMobile">
    
          <div class="close-cross" @click="close">
            <mdc-icon icon="close"></mdc-icon>
          </div>
  
          <header class="mdc-dialog__header  mdc-dialog__header--visible">
            <h2 class="mdc-dialog__header__title"> {{'protocol.add_to_set' | trans}}</h2>
          </header>
        </div>

        <div class="form-group row">
            <div class="col-md-12" v-if="stimulusList.length">
                <div class="alert-danger text-center mb-3" v-if="errorsStimulLenght">{{'protocol.errorResult' | trans}}</div>
                <div v-for="(stimul, index) in stimulusList" :key="index"
                     class="radio-btn selectable"
                     :class="{'active' : stimul.selected}"
                     @click="setActiveStimul(stimul)">
                    {{stimul.description}}
                </div>
            </div>
            <div class="col-md-12" v-else>
              <p>{{'protocol.no_available_set_create' | trans}}</p>
            </div>
        </div>
  
      <footer class="col-12 px-0 mdc-dialog__footer mdc-dialog__footer--visible" v-if="isMobile">
        <button type="button" class="col-12 mdc-button mdc-button--raised button-primary" @click="validate()">
          <span>{{'behavior.buttons.create' | trans}}</span>
        </button>
      </footer>


    </mdc-dialog>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep';
  import {mapGetters, mapActions, mapState} from 'vuex';
  import forEach from 'lodash/forEach';
  import map from 'lodash/map';
  import filter from 'lodash/filter';
  import lang from '../../../lang/translator';

  export default {
    name: 'addHintModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'stimulList': {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        stimulusList: [],
        errorsStimulLenght:false,

      };
    },
    computed: {

      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        }
      },

      ...mapGetters('mobile', [
        'isMobile',
      ]),

    },
    mounted (){
      this.stimulusList = cloneDeep(this.stimulList)
    },
    beforeDestroy() {
    },
    methods: {
      close(selectedStimul) {
          this.$emit('close');
      },

      async validate() {

        this.errors.clear();
        if(!this.stimulusList.length){
          this.$emit('cancel');
        }
        
        let selectedStimulus = filter(this.stimulusList, 'selected');
        let selectedStimul = map(selectedStimulus, (task,index) => {
            return {
              globalUuid: task.globalUuid,
              index: index
            };
        });

        if(selectedStimul.length == 3){
          this.$emit('close', selectedStimul);
        }
        else {
            this.errorsStimulLenght = true;
        }
      },

      cancel() {
        this.$emit('cancel');
      },
      setActiveStimul(stimul) {
        let list = cloneDeep(this.stimulusList)
        forEach(list, (item) => {
          if(stimul.globalUuid === item.globalUuid){
            item.selected = !item.selected
          }
        });
        this.stimulusList = list;
      },
    },
    watch: {

    }
  };
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/AddHintModal.vue